//Custom components

//Services
import { useDashboardData } from '@/hooks/ReactQueryHooks/useDashboardQuery';
//Assets and Miscellaneous
import type { DashboardType } from '@/types/Analytics.ts';
import { transformProjectTypeChartDataSets } from '@/utils';
import Card from '../../UI/Card/index.tsx';
import PieChart from '../../UI/Charts/PieChart';
import { Widget } from '../constants';
import WidgetLayout from '../WidgetLayout';

export interface ConstructionTypeWidgetDataResponse {
  constructionType: string;
  _count: number;
}

export default function ConstructionTypeWidget({ dashboard }: { dashboard: DashboardType }) {
  const fetchConstructionTypeWidgetData = useDashboardData({
    dashboard,
    widget: Widget.PROJECTS_BY_CONSTRUCTION_TYPE,
  });

  const constructionTypeWidgetData = fetchConstructionTypeWidgetData?.data?.data;

  const constructionTypeLabels = constructionTypeWidgetData?.map((data: ConstructionTypeWidgetDataResponse) => data?.constructionType);

  const projectsByConstructionType = constructionTypeWidgetData?.map((data: ConstructionTypeWidgetDataResponse) => {
    return { type: data?.constructionType, count: data?._count };
  });

  const totalConstructionType = constructionTypeWidgetData?.reduce((acc: number, data: ConstructionTypeWidgetDataResponse) => {
    return acc + data?._count;
  }, 0);

  return (
    <WidgetLayout dashboard={dashboard} widget={Widget.PROJECTS_BY_CONSTRUCTION_TYPE}>
      <Card title='Projects By Construction Type' error={fetchConstructionTypeWidgetData.isError}>
        {constructionTypeWidgetData && (
          <div className='relative p-5 h-80'>
            <div className='absolute px-5 text-center'>
              <h3 className='text-gray-500 font-bold'>Total projects</h3>
              <h1 className='m-0'>{totalConstructionType}</h1>
            </div>
            <div className='md:w-7/8 xl:w-full h-full'>
              <PieChart
                labels={constructionTypeLabels}
                datasets={transformProjectTypeChartDataSets(projectsByConstructionType)}
                chartTitle='Total Project Types'
              />
            </div>
          </div>
        )}
      </Card>
    </WidgetLayout>
  );
}
